"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _tr = _interopRequireDefault(require("./views/tr"));

var _themeOptimized = _interopRequireDefault(require("../themeOptimized"));

var _react = _interopRequireWildcard(require("react"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var withForkTable = function withForkTable(themeOverride) {
  var ForkThemeMiddleware = function ForkThemeMiddleware(_ref) {
    var theme = _ref.theme,
        rest = (0, _objectWithoutProperties2["default"])(_ref, ["theme"]);
    var forkedTheme = (0, _react.useMemo)(function () {
      return _objectSpread({}, theme, {
        tr: (0, _mergeTheme["default"])(theme.tr, themeOverride)
      });
    }, [theme]);
    return _react["default"].createElement(_tr["default"], (0, _extends2["default"])({
      theme: forkedTheme
    }, rest));
  };

  return (0, _themeOptimized["default"])(ForkThemeMiddleware, 'table');
};

var _default = withForkTable;
exports["default"] = _default;